import { useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 990, // <--- ISKO 1040 SE 990 KAR DO
            backdropFilter: "blur(4px)",
          }}
        />
      )}
      <header className="navbar">
        <div className="logo">
          <span>⚡</span> TechSphere
        </div>
        <div
          className={`hamburger ${open ? "toggle" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
        <ul className={`nav-links ${open ? "active" : ""}`}>
          <li>
            <Link to="/" onClick={() => setOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/courses" onClick={() => setOpen(false)}>
              Courses
            </Link>
          </li>
          <li>
            <Link to="/services" onClick={() => setOpen(false)}>
              Services
            </Link>
          </li>
          <li>
            <Link to="/login" onClick={() => setOpen(false)}>
              Login
            </Link>
          </li>
          <li className="nav-cta">
            <Link to="/apply" onClick={() => setOpen(false)}>
              Apply Now
            </Link>
          </li>
        </ul>
      </header>
    </>
  );
}
export default Navbar;
